// utils/propertyFormHelpers.js

export const handleProjectChange = (
  e,
  projects,
  handleChange
) => {
  const selected = projects.find(
    (p) =>
      p.id === Number(e.target.value)
  );

  handleChange({
    target: {
      name: "projectId",
      value: selected?.id || "",
    },
  });

  handleChange({
    target: {
      name: "projectName",
      value: selected?.name || "",
    },
  });
};

export const toggleAmenity = (
  amenity,
  amenities,
  handleChange
) => {
  const updatedAmenities =
    amenities.includes(amenity)
      ? amenities.filter(
          (item) => item !== amenity
        )
      : [...amenities, amenity];

  handleChange({
    target: {
      name: "amenities",
      value: updatedAmenities,
    },
  });
};